import React, { useState, useEffect } from 'react';
import { Button, Col, Row, InputGroup, Form } from 'react-bootstrap';
import { useProvider, Toast } from '../../context/MenuProvider';


const BotaoRodape = ({ produto, empresa, observacoes, setObservacoes, loading, botao }) => {
  const [quantidade, setQuantidade] = useState(1);
  const {
    buscarDadosPorId,
    salvarDados,
    navigateTo,
  } = useProvider();
  
  const addOrUpdateProduto = async () => {
    try {
      const response = await buscarDadosPorId('local_registros', 'sacola');
      let sacola = (response) ? response : { itens: [] };

      sacola.itens = (sacola.itens || []).filter(x => 
        x?.produto?.empresa === empresa?.id
      );
      
      let itensAtualizados = [];
      const index = sacola.itens.findIndex(item => item.produto.id === produto.id);
  
      if (index !== -1) {
        // Atualiza se já existir
        itensAtualizados = sacola.itens.map(item =>
          item.produto.id === produto.id
            ? { ...item, produto: produto, quantidade: quantidade, observacoes:observacoes }
            : item
        );
      } else {
        // Adiciona novo
        itensAtualizados = [...sacola.itens, { produto, quantidade, observacoes }];
      }
  
      const atualizado = { ...sacola, itens: itensAtualizados };
      await salvarDados("local_registros",{
        ...atualizado,
        id:"sacola"
      });
      navigateTo(-1);
    } catch (err) {
      alert(JSON.stringify(err))
      console.error('Erro ao adicionar/atualizar produto:', err);
    }
  };
    
  useEffect(()=>{
    if(quantidade<=0){
      setQuantidade(1);
    }
  },[quantidade])
  
  useEffect(() => {
    const carregarProduto = async () => {
      try {
        const response = await buscarDadosPorId('local_registros', 'sacola');
        if (response) {
          const item = response.itens.find(x => x.produto.id === produto.id);
          if (item) {
            setQuantidade(item.quantidade);
            setObservacoes(item.observacoes||``);
          }
        }
      } catch (err) {
        console.error('Erro ao atualizar quantidade:', err);
      }
    };
  
    if (produto) {
      carregarProduto();
    }
  }, [produto]);
  
  useEffect(()=>{
    if(quantidade<=0){
      setQuantidade(1);
    }
  },[quantidade])
  

  const totalComDesconto = parseFloat(produto?.preco_unitario*quantidade || 0) - parseFloat(0);
  const totalComDescontoFormatado = totalComDesconto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const totalOriginal = parseFloat(produto?.preco_unitario*quantidade || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  
  return (
    <>
      {produto && (
        <div className="bs-floating">
          <div className="container py-3">
            <InputGroup className="w-100 fs-3">
                <Button variant="secondary" className="px-3" onClick={()=>setQuantidade(quantidade-1)} disabled={loading}>
                  -
                </Button>
                <span className="input-group-text">{quantidade}</span>
                <Button variant="secondary" className="px-3" onClick={()=>setQuantidade(quantidade+1)} disabled={loading}>
                  +
                </Button>
                <Button variant="dark" className="flex-fill" onClick={addOrUpdateProduto} disabled={loading}>
                  {`Adicionar `} 
                  {parseFloat(0) > 0 && (
                    <s className="small px-1">{totalOriginal}</s>
                  )}
                  {totalComDescontoFormatado}
                </Button>
              </InputGroup>
          </div>
        </div>
      )}
    </>
  );
};

export default BotaoRodape;